import { useEffect } from 'react';

const WEB_BASE_URL = (process.env.REACT_APP_WEB_URL || 'http://localhost:8000').replace(/\/$/, '');

const isBladePublicPath = (pathname: string): boolean => {
  if (pathname === '/') {
    return true;
  }
  if (pathname === '/item') {
    return true;
  }
  if (/^\/item\/[^/]+$/.test(pathname)) {
    return true;
  }
  if (/^\/store\/[^/]+$/.test(pathname)) {
    return true;
  }
  if (pathname === '/store-search') {
    return true;
  }
  if (pathname === '/store-inquiry' || pathname === '/store-inquiry/complete') {
    return true;
  }
  return false;
};

/**
 * 開発時（:3000）に公開 Blade ページへアクセスした場合、Laravel 側へ転送する。
 * 本番は service/public/.htaccess で Blade ルートを Laravel に渡す。
 */
export const PublicPageRedirect = () => {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      return;
    }

    const { pathname, search } = window.location;
    if (!isBladePublicPath(pathname)) {
      return;
    }

    window.location.replace(`${WEB_BASE_URL}${pathname}${search}`);
  }, []);

  return null;
};
